import { useEffect } from "react";
import { startSessionWatcher, stopSessionWatcher } from "./sessionWatcher";
import { logout } from "../store/reducers/auth/auth.reducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

function SessionWatcher() {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken);

  useEffect(() => {
    if (!accessToken) return;

    startSessionWatcher(() => {
      alert("Su sesión ha expirado");
      dispatch(logout());
    });

    return () => stopSessionWatcher(); // limpia timer
  }, [accessToken, dispatch]);

  return null;
}

export default SessionWatcher;
